<ng-container *ngIf="transformedRowData?.length">
  <div class="filter-container">
    <app-grid-quick-filter [configStoreTableName]="configStoreTableName">
    </app-grid-quick-filter>
  </div>

  <app-ag-grid-options
    [showQuickFilter]="false"
    [configStoreTableName]="configStoreTableName"
  >
  </app-ag-grid-options>

  <div class="table-container">
    <ag-grid-angular
      columnHoverHighlight
      rowHoverHighlight
      class="ag-theme-adap ag-sticky"
      [rowData]="transformedRowData"
      [columnDefs]="columnDefs"
      [components]="components"
      domLayout="normal"
      rowClass="ag-no-border"
      configStore
      [configStoreTableName]="configStoreTableName"
      columnSizeStrategy="sizeColumnsToFit"
      suppressScrollOnNewData
    >
    </ag-grid-angular>
  </div>
</ng-container>
